<template>
  <div id="duration-content">
    <pvd-field-group id="topHeading">
      <div class="pvd-modal__heading">
        <img
          src="/prgw/digital/finewissues/client/assets/clock.svg"
          alt="Clock with the upper left corner not shaded in" />
        <h3 id="durationContentHeader" slot="heading">
          {{ clientConstants.DURATION_CONTENT_HEADER }}
        </h3>
      </div>
      <p id="durationContentSubHeader">
        {{ clientConstants.DURATION_CONTENT_SUB_HEADER }}
      </p>
    </pvd-field-group>
    <hr class="grayBar" aria-hidden="true" />
    <pvd-field-group>
      <div id="slider-component">
        <div id="time-period-slider-component">
          <fractional-cd-slider
            :id="`time-period-slider`"
            :values="clientConstants.timePeriodList"
            :currentValue="sliderIndex"
            @change="durationChanged($event)"></fractional-cd-slider>
        </div>
      </div>
      <pvd-button id="durationContentOptionsButton" pvd-type="submit" pvd-full-width @click="viewButtonClicked()">
        {{ clientConstants.DURATION_CONTENT_OPTIONS_BUTTON }}
      </pvd-button>
      <pvd-button
        id="durationContentBackButton"
        pvd-type="submit"
        pvd-full-width
        pvd-variant="secondary"
        @click="backButtonClicked()">
        {{ clientConstants.BACK_BUTTON }}
        <span class="screen-reader-only">(Goes back a page in the modal)</span>
      </pvd-button>
    </pvd-field-group>
    <pvd-progress-indicator pvd-active-step-index="1" pvd-steps='["","", ""]'> </pvd-progress-indicator>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/runtime-core';
import { ClientConstants } from './../client.constants';
import FractionalCdSlider from './FractionalCdSlider.vue';

export default defineComponent({
  name: 'DurationContent',
  components: { FractionalCdSlider },
  props: {
    sliderIndex: { type: Number, default: 3, required: false }
  },
  data: function () {
    return {
      currentValue: this.sliderIndex,
      clientConstants: ClientConstants
    };
  },
  methods: {
    durationChanged(event: Event): void {
      this.$emit('durationChanged', event);
    },
    viewButtonClicked() {
      this.$emit('closeDurationModal');
    },
    backButtonClicked() {
      this.$emit('backButtonClicked');
    }
  }
});
</script>

<style scoped lang="scss">
#topHeading {
  padding-right: 3rem;
  padding-left: 3rem;
}

#durationContentOptionsButton {
  display: block;
  margin: auto;
  width: 60%;
  margin-bottom: 1rem;
}

#durationContentBackButton {
  display: block;
  margin: auto;
  width: 60%;
  margin-bottom: 4rem;
}

#time-period-slider-component {
  width: 60%;
  display: block;
  margin: auto;
  margin-top: 2rem;
  margin-bottom: 4rem;

  @media (max-width: 601px) {
    width: 100%;
    margin-top: 2rem;
    margin-bottom: 4rem;
  }
}

.helperText {
  margin-left: 7rem;
}

@media (max-width: 425px) {
  .helperText {
    margin-left: 5rem;
  }
}

img {
  display: block;
  margin: auto;
}

#durationContentHeader {
  text-align: center;
  display: block;
}
#durationContentSubHeader {
  text-align: center;
  margin-bottom: 2rem;
}
</style>
